
export default function Footer() {
  const currentYear = new Date().getFullYear();

  const services = [
    'General Pest Control',
    'Mosquito Services',
    'Rodent Control'
  ];

  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <h3 className="text-2xl font-bold mb-4 tracking-wide" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              YOUNG GUNS PEST CONTROL
            </h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Your trusted local pest control experts. Protecting homes and businesses in our community.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <a href="#services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-phone-line text-green-400"></i>
                </div>
                <a href="tel:(682)600-1829" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  (682) 600-1829
                </a>
              </div>
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-mail-line text-green-400"></i>
                </div>
                <a href="mailto:Younggunspest@gmail.com" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Younggunspest@gmail.com
                </a>
              </div>
              <div className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center mr-3 mt-1">
                  <i className="ri-map-pin-line text-green-400"></i>
                </div>
                <div className="text-gray-300">
                  <p>6001 Barton Hills, Unit 517</p>
                  <p>Fort Worth, Texas 76112</p>
                </div>
              </div>
              <div className="flex items-center">
                <div className="w-5 h-5 flex items-center justify-center mr-3">
                  <i className="ri-time-line text-green-400"></i>
                </div>
                <div className="text-gray-300">
                  <p>Mon-Fri: 8AM-6PM</p>
                  <p>Emergency: 24/7</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6 mb-4 md:mb-0">
              <p className="text-gray-400 text-sm">
                © {currentYear} Young Guns Pest Control. All rights reserved.
              </p>
              <div className="flex items-center space-x-4 text-sm">
                <span className="text-gray-400">Privacy Policy</span>
                <span className="text-gray-400">Terms of Service</span>
                <span className="text-gray-400">Sitemap</span>
              </div>
            </div>
            
            <div className="flex items-center space-x-4">
              <div className="flex items-center text-sm text-gray-400">
                <div className="w-4 h-4 flex items-center justify-center mr-2">
                  <i className="ri-shield-check-line text-green-400"></i>
                </div>
                Licensed & Insured
              </div>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer"
              >
                Made with Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
